import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PvsDesignSystemProvider } from 'pvs-design-system';
const themeOptions = {
    typography: {
        htmlFontSize: 10,
    },
    spacing: (factor) => `${(0.8 * factor).toFixed(3)}rem`,
};
const ThemeProvider = ({ children = undefined, }) => {
    return (_jsx(PvsDesignSystemProvider, { themeOptions: themeOptions, children: children }));
};
export default ThemeProvider;
